// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3kzgU","label":"Labeled_label__1N5nG","divider":"Labeled_divider__1gzFL"};